/**
 * Tailwind ne gère pas les classes dynamiques, ici row-span-N.
 * On utilise donc un objet pour gérer les classes en fonction du nombre d'éléments.
 */
export const rowSpanClassMap: Record<number, string> = {
  1: "row-span-1",
  2: "row-span-2",
  3: "row-span-3",
  4: "row-span-4",
  5: "row-span-5",
  6: "row-span-6",
  7: "row-span-7",
  8: "row-span-8",
  9: "row-span-9",
  10: "row-span-10",
};
